import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { BaseView } from '@wizeoo/akm-common-lib';

import { Model } from 'src/app/model/model';

@Component({
  selector: 'log-view',
  templateUrl: './log.view.html',
})
// Vue d'initialisation pour chargement du contexte
export class LogView extends BaseView {

  constructor(public elementRef: ElementRef, public cdref: ChangeDetectorRef ) {
    super(elementRef);
    this.code = 'LOG';
  }

  public get logs(): string {
    let res: string = '';
    if(Model.getInstance().logs.length > 0) {
      res = Model.getInstance().logs.join('\r\n');
    }
    return res;
  }


}